export const initValues = {
  student: {
    period: '',
    firstName: '',
    lastName: '',
    birthdateAttestation: null,
    ssin: '',
    street: '',
    houseNr: '',
    busNr: '',
    city: '',
    zipCode: '',
    hasOtherAddress: ''
  },
  parent: {
    firstName: '',
    lastName: '',
    ssin: '',
    street: '',
    houseNr: '',
    busNr: '',
    city: '',
    zipCode: '',
    siteLang: ''
  }
}

export const initErrors = {
  student: {},
  parent: {}
}

export const initComponentErrors = {
  student: {},
  parent: {}
}